import { useDeleteAgitemdetail } from "http-hooks/agitemdetail.js/useAgitemdetail";
import DeleteConfirmation from "components/ui/DeleteConfirmation";

export default function DeleteItemDetail({ id, onClose }) {
  const { mutateAsync, isPending } = useDeleteAgitemdetail();

  const handleDelete = async () => {
    try {
      await mutateAsync(id);
      onClose();
    } catch (error) {
      // Error toast already shown by service
      console.error("Delete failed:", error);
    }
  };

  return (
    <DeleteConfirmation
      title="Delete Item Detail"
      description="Are you sure you want to delete this Item Detail? This Item Detail will be permanently removed. This action cannot be undone."
      onDelete={handleDelete}
      onClose={onClose}
      isLoading={isPending}
    />
  );
}
